<template>
  <form class="chi-form chi-login" @submit.prevent="submit" v-show="!$root.logged_in">
    <div class="container">
      <chi-welcome></chi-welcome>
      <div class="chi-form-section right">
        <chi-announcements></chi-announcements>
        <div class="chi-form-section login-form">
          <h2 class="with-cropped-hr centered">Log Into Your Account</h2>
          <div class="chi-login-errors" id="chi-login-notifications"
            data-conn-message="Failed to connect to server. Please try again later."
            data-fail-message="Invalid username and/or password!"
            data-pass-message="Password cannot be blank!"
            data-user-message="Username cannot be blank!"
          ></div>
          <div class="chi-form-group input-group" :class="{'has-chi-login-error': error.user}">
            <label class="chi-login-label" for="user">Username</label>
            <input class="k-textbox full-width" id="user" ref="user" tabindex="1" type="text" :name="random" :class="{'k-space-right': error.user}" v-model.lazy="model.username" v-if="user_visible" @keypress="onkeypress" />
            <i class="fal fa-fw fa-exclamation-circle chi-login-error-icon" :title="error.user ? 'Invalid or blank username' : ''" v-if="error.user"></i>
          </div>
          <div class="chi-form-group input-group" :class="{'has-chi-login-error': error.pass}">
            <label class="chi-login-label" for="pass">Password</label>
            <input class="k-textbox full-width" id="pass" name="pass" ref="pass" tabindex="2" type="password" :class="{'k-space-right': error.pass}" v-model.lazy="model.password" @keypress="onkeypress" />
            <i class="fal fa-fw fa-exclamation-circle chi-login-error-icon" :title="error.pass ? 'Invalid or blank password' : ''" v-if="error.pass"></i>
          </div>
          <div class="chi-button-group chi-form-group">
            <kendo-button class="chi-button-primary" id="login" sprite-css-class="chi-icon-log-in" tabindex="3" type="submit">Log In</kendo-button>
            <kendo-button id="clear" sprite-css-class="chi-icon-backspace" tabindex="4" type="reset" @click="clear()">Clear</kendo-button>
          </div>
          <a class="tos" name="tos">Terms of Service</a>
          <div class="chi-form-group chi-accessibility" v-if="!!launch_accessibility">
            For accessibility settings, <span v-html="launch_accessibility"></span>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>


<style lang="scss">
  .chi-form.chi-login {
    background: linear-gradient(to right, #3c4752 0 calc(50% + 21.14rem), #f8f8f9 calc(50% + 21.14rem) 100%);
    height: 100%;
    padding: 0;
    width: 100%;
    .container {
      height: 100%;
      margin: 0 auto;
      width: 97.14rem;
      &>.chi-form-section {
        float: left;
        height: 100%;
        padding: 2.286rem;
        position: relative;
        &.left {
          width: 69.71rem;
        }
        &.right {
          width: 27.43rem;
        }
        h1 {
          clear: initial;
          color: white;
          float: initial;
          height: 1em;
          font-size: 40px;
          font-weight: initial;
          margin: initial;
          margin-top: 5.714rem;
          padding: initial;
          text-transform: none;
          width: initial;
        }
        h2 {
          font-size: 20px;
          text-transform: uppercase;
        }
        .branding-container {
          .picture-frame {
            height: 14.29rem;
            margin: 2.286rem;
            width: 12.86rem
            img {
              height: 100%;
              width: 100%;
            }
          }
          p {
            color: white;
            line-height: 175%;
            margin-top: 1.143rem;
            a {
              color: inherit;
            }
          }
        }
        .cpt-wrapper {
          bottom: 2.286rem;
          left: 2.286rem;
          margin: 0;
          position: absolute;
          width: 65.14rem;
        }
        .cpt-container {
          color: rgba(128, 128, 128, 0.625);
          font-size: 10pt;
          float: left;
          width: 31.43rem;
          &.right {
            float: right;
          }
          p:first-of-type {
            font-weight: bold;
            text-decoration: underline;
          }
          p:not(:first-of-type) {
            font-style: italic;
          }
        }
        .chi-announcements {
          max-height: 47.5em;
          overflow: auto;
          .chi-announcement {
            color: #676d75;
            float: left;
            width: 100%;
            &:first-of-type {
              margin-top: 1.143rem;
            }
            h3 {
              border-bottom: 1px solid rgba(0, 0, 0, 0.08);
              color: #4c8de0;
              font-size: 14px;
              margin: initial;
              padding: 0.2857rem;
              width: 100%;
              .chi-pub-date {
                color: #9c9c9c;
                display: inline-block;
                float: right;
                font-weight: normal;
              }
            }
            a {
              color: #4c8de0;
            }
          }
        }
        .chi-form-section.login-form {
          bottom: 2.286rem;
          height: auto;
          position: absolute;
          right: 3.429rem;
          width: 20.57rem;
          .windows {
            height: 21.5rem;
          }
          .chi-form-group {
            color: #676d75;
            margin: 1.1429rem 0 0 0;
            position: relative;
            width: 100%;
            &.chi-accessibility {
              color: darken(#676d75, 25%);
              line-height: normal;
              margin-top: 2.286rem;
              text-align: center;
            }
            &.input-group {
              margin: 1.1429rem 10% 0 10%;
              width: 80%;
            }
            label {
              text-align: left;
            }
          }
          .chi-button-group {
            text-align: center;
            .k-button {
              float: none;
            }
          }
          .tos {
            color: #9c9c9c;
            display: inline-block;
            font-size: 12px;
            margin-top: 1.143rem;
            text-align: center;
            text-decoration: none;
            width: 100%;
          }
          .has-chi-login-error {
            .chi-login-label {
              color: #a22;
            }
            .k-textbox {
              border-color: #a22;
            }
            .chi-login-error-icon  {
              display: block;
            }
          }
          .chi-login-error-icon {
            bottom: 0.57143rem;
            color: #a22;
            display: none;
            margin: 0.5em 0 0 0;
            overflow: visible;
            position: absolute;
            right: 1.5rem;
            width: 0;
            &:before {
              color: #a22;
            }
          }
          .chi-login-errors {
            float: left;
            width: 100%;
            &.active {
              margin-top: 1.143rem;
            }
            .k-notification {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>


<script>
import $ from 'jquery';
import {Button} from '@progress/kendo-buttons-vue-wrapper';
import Announcements from './announcements';
import Welcome from './welcome';

var launch_accessibility = '';
switch (window.os) {
case 'windows':
  launch_accessibility = 'press <i class="fab fa-windows"></i>+U';
  break;
case 'mac':
  launch_accessibility = '<br />press Option + Command + F5';
  break;
case 'ios':
  launch_accessibility = 'triple-click the Home or Side button';
  break;
case 'chrome':
  launch_accessibility = 'please<br /><a href="https://support.google.com/chromebook/answer/177893" target="_blank">follow these instructions</a>';
  break;
}

export default {
  name: 'Login',
  components: {
    'chi-announcements': Announcements,
    'chi-welcome': Welcome,
    'kendo-button': Button
  },
  computed: {
    announcements: function () {
      return this.raw_announcements.filter(function (item) {
        var now = Date.now();
        return !(item.start > now || item.end < now);
      });
    }
  },
  data: function () {
    return {
      raw_announcements: [{
        start: new Date('11/18/2021'),
        end: new Date('01/03/2022 23:59:59'),
        title: 'Happy Holiday Season!',
        date: '11/18/2021',
        content: 'The hol&shy;i&shy;day sea&shy;son will be quick&shy;ly up&shy;on us and at this bus&shy;y time of year CCC wants to en&shy;sure qual&shy;i&shy;ty ser&shy;vice for your clin&shy;ics. In prep&shy;a&shy;ra&shy;tion, please note our hol&shy;i&shy;day sched&shy;ule:'
      }, {
        start: new Date('11/18/2021'),
        end: new Date('11/29/2021 23:59:59'),
        title: 'Thanksgiving Holiday',
        content: 'CCC will be closed Thurs&shy;day, No&shy;vem&shy;ber 25<sup>th</sup>.<br />There will be no cou&shy;ri&shy;er ser&shy;vice or phone cov&shy;er&shy;age on Thurs&shy;day or Fri&shy;day. Job sched&shy;ules that are pro&shy;cessed 11/24–11/28 will be de&shy;liv&shy;ered on Mon&shy;day, No&shy;vem&shy;ber 29<sup>th</sup>.'
      }, {
        start: new Date('11/18/2021'),
        end: new Date('12/27/2021 23:59:59'),
        title: 'Christmas Holiday',
        content: 'CCC will be closed Fri&shy;day, De&shy;cem&shy;ber 24<sup>th</sup>.<br />Job sched&shy;ules that are pro&shy;cessed 12/23–12/26 will be de&shy;liv&shy;ered on Mon&shy;day, De&shy;cem&shy;ber 27<sup>th</sup>.'
      }, {
        start: new Date('11/18/2021'),
        end: new Date('01/03/2022 23:59:59'),
        title: 'New Year Holiday',
        content: 'CCC will be closed Fri&shy;day, De&shy;cem&shy;ber 31<sup>st</sup>.<br />Job sched&shy;ules that are pro&shy;cessed 12/30–1/2 will be de&shy;liv&shy;ered on Mon&shy;day, Jan&shy;u&shy;ar&shy;y 3<sup>rd</sup>.'
      }, {
        start: new Date('11/18/2021'),
        end: new Date('01/03/2022 23:59:59'),
        content: 'As al&shy;ways, the 24-hour e&shy;mer&shy;gen&shy;cy num&shy;ber is <a href="tel://+14023412251">(402) 341-2251</a>. Please fol&shy;low the mes&shy;sage prompts for the on&shy;call staff per&shy;son to re&shy;turn your call.<br /><br />All of us at CCC wish you and your fam&shy;i&shy;ly a won&shy;der&shy;ful hol&shy;i&shy;day sea&shy;son and pros&shy;per&shy;ous New Year. Please con&shy;tact Cli&shy;ent Ser&shy;vic&shy;es or the Bill&shy;ing Staff for an&shy;y ques&shy;tions.'
      }],
      launch_accessibility: launch_accessibility,
      time_of_day: this.get_time_of_day(),
      error: {
        user: undefined,
        pass: undefined
      },
      model: {
        username: undefined,
        password: undefined
      },
      user_visible: true
    }
  },
  errors: undefined,
  notifications: undefined,
  methods: {
    onkeypress: function (event) {
      if (event.which > 31 && event.which < 127)
        try {
          switch (event.target.getAttribute('id')) {
          case 'user':
            this.error.user = undefined;
            break;
          case 'pass':
            this.error.pass = undefined;
            break;
          default:
            console.warn('Unexpected field ' + event.target.getAttribute('id'));
            console.debug(event);
          }
        } catch (e) {
          console.error(e);
          console.debug(event);
        }
    },
    clear: function (reset) {
      this.$options.notifications.hide();
      this.error.user = this.error.pass = undefined;
      this.model.username = this.model.password = undefined;
      if (reset) {
        this.user_visible = false;
        this.user_visible = true;
      }
      if (this.$refs.user)
        this.$refs.user.focus();
    },
    get_time_of_day: function (self) {
      self = self || this;
      var hours = (new Date()).getHours();
      self.time_of_day =
        hours < 12 ? 'Morning' : (hours < 17 ? 'Afternoon' : 'Evening');
      return self.time_of_day;
    },
    random: function () {
      return (new Date()).getTime().toString(16);
    },
    reset: function () {
      this.$root.reset();
      this.clear(true);
    },
    show_error: function (type) {
      this.$options.notifications.error(this.$options.errors.data(type));
    },
    submit: function () {
      var self = this;
      this.$options.notifications.hide();
      if (this.validate()) {
        kendo.ui.progress($('.chi-form-section.login-form'), true);
        $.ajax({
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify(this.model),
          type: 'POST',
          url: '/login'
        }).done(function (response) {
          self.clear();
          if (!response.token) {
            self.show_error('conn-message');
            self.$refs.user.focus();
          } else {
            self.$root.token = response.token;
            if (response.twofa)
              self.$root.twofa(response.twofa);
            else
              self.$root.login(function (connected) {
                if (!connected) {
                  self.show_error('conn-message');
                  self.$refs.user.focus();
                }
              });
          }
        }).fail(function (xhr) {
          kendo.ui.progress($('.chi-form-section.login-form'), false);
          if (xhr.status === 403) {  // Forbidden
            $('<div id="chi-dialog"></div>')
              .appendTo(document.body)
              .kendoDialog({
                actions: [],
                content: xhr.responseJSON && xhr.responseJSON.message,
                title: 'Freedom 6.0 Test Server',
                width: '360px',
                open: function () {
                  this.wrapper
                    .addClass('chi-info-dialog')
                    .find('.k-dialog-action')
                      .css('visibility', 'hidden');
                },
                close: function () {
                  event.preventDefault();
                  event.stopImmediatePropogation();
                  return false;
                }
              });
            setTimeout(function () {
              self.clear();
            }, 300);
          } else {
            setTimeout(function () {
              self.clear();
              self.show_error('fail-message');
              $('#user').focus();
            }, 300);
          }
        });
      }
    },
    validate: function () {
      this.error.user = !this.model.username && this.model.username !== 0;
      this.error.pass = !this.model.password && this.model.password !== 0;
      if (this.error.user)
        this.show_error('user-message');
      if (this.error.pass)
        this.show_error('pass-message');
      if (this.error.user)
        this.$refs.user.focus();
      else if (this.error.pass)
        this.$refs.pass.focus();
      else
        return true;
    }
  },
  mounted: function () {
    $('#user').focus();
    var element = this.$options.errors = $('#chi-login-notifications');
    this.$options.notifications = new kendo.ui.Notification(element, {
      appendTo: '#chi-login-notifications',
      autoHideAfter: 10000,
      hide: function () {element.toggleClass('active', false)},
      show: function () {element.toggleClass('active', true)}
    });
    setTimeout(function (self) {
      self.get_time_of_day();
      setInterval(self.get_time_of_day, 1000 * 60, self);
    }, 1000 * (60 - (new Date()).getSeconds()), this);
  }
};
</script>
